module.exports = __webpack_public_path__ + "img/EMS_user_manual_timeline3.7502df55.png";